"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactVirtualized = require("react-virtualized");
var _utils = require("./utils");
var _ = _interopRequireWildcard(require("./"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DEFALUT_TEXT = 'Label';
var MAX_HEIGHT = 450;
function LabelPill(props, ref) {
  var onSelect = props.onSelect,
    labels = props.labels;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedLabels = _useState2[0],
    setSelectedLabels = _useState2[1];
  var _useState3 = (0, _react.useState)(DEFALUT_TEXT),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    showText = _useState4[0],
    setShowText = _useState4[1];
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      clear: function clear() {
        setSelectedLabels([]);
        setShowText(DEFALUT_TEXT);
      }
    };
  });
  var autoHeight = (0, _utils.getAutoHeight)(labels.length, MAX_HEIGHT, 45);
  function renderItem(_ref) {
    var index = _ref.index,
      style = _ref.style,
      key = _ref.key;
    var selectLabelId = selectedLabels.map(function (label) {
      return label.id;
    });
    var label = labels[index];
    var active = selectLabelId.includes(label.id);
    return /*#__PURE__*/_react["default"].createElement(_.PillItem, {
      key: key,
      style: style,
      color: label.color,
      active: active,
      text: label.name,
      onClick: function onClick() {
        var next = [];
        if (!active) {
          next = [].concat((0, _toConsumableArray2["default"])(selectedLabels), [label]);
        } else {
          next = selectedLabels.filter(function (item) {
            return item.id !== label.id;
          });
        }
        setSelectedLabels(next);
        onSelect(next);
        var showText = (0, _.getShowText)(next, 'name', {
          defalutText: DEFALUT_TEXT
        });
        setShowText(showText);
      }
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_["default"], {
    isActive: !!selectedLabels.length,
    showText: showText,
    defalutText: DEFALUT_TEXT
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-64 text-dark text-lg"
  }, /*#__PURE__*/_react["default"].createElement(_reactVirtualized.InfiniteLoader, {
    isRowLoaded: function isRowLoaded(index) {
      return !!labels[index];
    },
    loadMoreRows: function loadMoreRows() {
      return null;
    },
    rowCount: labels.length
  }, function (_ref2) {
    var onRowsRendered = _ref2.onRowsRendered,
      registerChild = _ref2.registerChild;
    return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.List, {
      ref: function ref(node) {
        registerChild(node);
      },
      height: autoHeight,
      onRowsRendered: onRowsRendered,
      rowCount: labels.length,
      rowHeight: 45,
      rowRenderer: renderItem,
      overscanRowCount: 5,
      width: 256
    });
  })));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(LabelPill);
//# sourceMappingURL=Label.js.map